import * as i0 from "@angular/core";
var DBkeys = /** @class */ (function () {
    function DBkeys() {
    }
    DBkeys.CURRENT_USER = 'current_user';
    DBkeys.USER_PERMISSIONS = 'user_permissions';
    DBkeys.ACCESS_TOKEN = 'access_token';
    DBkeys.REFRESH_TOKEN = 'refresh_token';
    DBkeys.TOKEN_EXPIRES_IN = 'expires_in';
    DBkeys.REMEMBER_ME = 'remember_me';
    DBkeys.guestQuestion = 'guestQuestion';
    DBkeys.LANGUAGE = 'language';
    DBkeys.HOME_URL = 'home_url';
    DBkeys.THEME_ID = 'themeId';
    DBkeys.SHOW_DASHBOARD_STATISTICS = 'show_dashboard_statistics';
    DBkeys.SHOW_DASHBOARD_NOTIFICATIONS = 'show_dashboard_notifications';
    DBkeys.SHOW_DASHBOARD_TODO = 'show_dashboard_todo';
    DBkeys.SHOW_DASHBOARD_BANNER = 'show_dashboard_banner';
    DBkeys.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DBkeys_Factory() { return new DBkeys(); }, token: DBkeys, providedIn: "root" });
    return DBkeys;
}());
export { DBkeys };
